import { render, staticRenderFns } from "./pucks.vue?vue&type=template&id=e6e87750"
import script from "./pucks.vue?vue&type=script&lang=js"
export * from "./pucks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports